import { useWorkerCustomToBaseQualificationNameMap } from "@src/appV2/Qualifications/useWorkerCustomToBaseQualificationNameMap";

import { useListViewOpenShiftsData } from "../../ListView/useListViewOpenShiftsData";
import { filterOpenShifts } from "../filterOpenShifts";
import { useShiftDiscoveryUserFiltersContext } from "../useUserFiltersContext";
import type { FiltersFormValues } from "./types";

export function useFilteredOpenShiftsCount(formValues: FiltersFormValues) {
  const { dates } = useShiftDiscoveryUserFiltersContext();

  const { distance, includeWindowedOutShifts, ...localUserFilters } = formValues;

  const {
    shifts = [],
    workplacesMap,
    isLoading,
  } = useListViewOpenShiftsData({
    distance,
    includeWindowedOutShifts,
  });

  const customToBaseQualificationNameMap = useWorkerCustomToBaseQualificationNameMap();

  const filteredOpenShiftsData = filterOpenShifts(
    { shifts, workplacesMap },
    { dates, ...localUserFilters },
    customToBaseQualificationNameMap
  );

  return {
    count: filteredOpenShiftsData.length,
    isLoading,
  };
}
